module.exports = __webpack_public_path__ + "static/media/users2.afb74007.svg";